import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../service/http.service';
import { SchoolService } from '../service/school.service';
import { BookingsSearchService } from '../service/bookings-search.service';
import { Language } from '../language';
import { SimpleSchoolBooking } from '../simple-school-booking';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-school-bookings',
  templateUrl: './school-bookings.component.html',
  styleUrls: ['./school-bookings.component.css']
})
export class SchoolBookingsComponent implements OnInit {

  bookings: SimpleSchoolBooking[] = [];
  languages: Language[] = [];
  @ViewChild('dataTable') table!: Table;

  constructor(
    private httpService: HttpService,
    private schoolService: SchoolService,
    private router: Router,
    public bookingSearchService: BookingsSearchService
  ) { }

  ngOnInit(): void {
    this.httpService.getSimpleBookingsBySchoolId(this.schoolService.selectedSchoolId).subscribe(res => {
      this.bookings = res;
    });
    this.httpService.getLanguages().subscribe(res => {
      this.languages = res;
    });
  }

  onDateSelect(value: Date, colName: string) {
    this.table.filter(moment(value).format("YYYY-MM-DD"), colName, 'equals');
  }

  openBooking(booking: SimpleSchoolBooking) {
    let url = this.router.serializeUrl(
      this.router.createUrlTree(["/management/edit-booking/" + booking.id])
    );
    window.open(url, "_blank");
  }

}
